/**
 * author:brian
 * date:2021.04.23
 * content:本模块js用于对系统按钮权限的控制
 * **/

import Vue from 'vue';
Vue.directive('has', {
    inserted(el, binding, vnode) {
        const { value } = binding;
        const roles = vnode.context.$store.state.auth || JSON.parse(sessionStorage.getItem('BtnPromision')) || []; //获取mate中的权限
        if (value && value instanceof Array && value.length > 0) {
            return true;

            const permissionRoles = value;
            const hasPermission = roles.some(role => {
                return permissionRoles.includes(role);
            });
            if (!hasPermission) {
                //  date 2022 04 25 权限的修改整理  这里先注释
                // el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`需要的权限`);
        }
    }
});
